import { ModelPath, PathToken, PathTokens } from "./ModelPath";
import { ModelPathBuilder } from "./ModelPathBuilder";

export type PathMatching = PathMatchingPart[];

export type PathMatchingPart =
    | {
          kind: MatchKind.MatchedPath;
          prefix: ModelPath;
      }
    | {
          kind: MatchKind.DifferentSuffix;
          source: ModelPath | undefined;
          target: ModelPath | undefined;
      }
    | {
          kind: MatchKind.MatchedMultiplicity;
          source: PathToken;
          target: PathToken;
      };

export enum MatchKind {
    MatchedPath = "MatchedPath",
    DifferentSuffix = "DifferentSuffix",
    MatchedMultiplicity = "MatchedMultiplicity",
}

export class PathMatcher {
    public static match(leftParts: readonly PathToken[], rightParts: readonly PathToken[]): PathMatching {
        const result: PathMatching = [];

        let samePrefix = new ModelPathBuilder(true);
        let differentSuffix: PathMatchingPart | undefined;

        const partCount = Math.max(leftParts.length, rightParts.length);

        for (let i = 0; i < partCount; i++) {
            const sourcePart: undefined | PathToken = leftParts[i];
            const targetPart: undefined | PathToken = rightParts[i];

            if (
                PathTokens.isSimpleToken(sourcePart) &&
                PathTokens.isSimpleToken(targetPart) &&
                sourcePart === targetPart
            ) {
                samePrefix.append(targetPart);
                continue;
            }
            if (PathTokens.isMultiToken(sourcePart) && PathTokens.isMultiToken(targetPart)) {
                if (!samePrefix.empty) {
                    result.push({
                        kind: MatchKind.MatchedPath,
                        prefix: samePrefix.toPath(),
                    });
                    samePrefix = new ModelPathBuilder(false);
                }
                result.push({
                    kind: MatchKind.MatchedMultiplicity,
                    source: sourcePart,
                    target: targetPart,
                });
                continue;
            }
            if (PathTokens.isMultiToken(sourcePart) && PathTokens.isInstanceToken(targetPart)) {
                if (!samePrefix.empty) {
                    result.push({
                        kind: MatchKind.MatchedPath,
                        prefix: samePrefix.toPath(),
                    });
                    samePrefix = new ModelPathBuilder(false);
                }
                result.push({
                    kind: MatchKind.MatchedMultiplicity,
                    source: sourcePart,
                    target: targetPart,
                });
                continue;
            }
            if (PathTokens.isInstanceToken(sourcePart) && PathTokens.isMultiToken(targetPart)) {
                if (!samePrefix.empty) {
                    result.push({
                        kind: MatchKind.MatchedPath,
                        prefix: samePrefix.toPath(),
                    });
                    samePrefix = new ModelPathBuilder(false);
                }
                result.push({
                    kind: MatchKind.MatchedMultiplicity,
                    source: sourcePart,
                    target: targetPart,
                });
                continue;
            }

            const sourcePartDifference = new ModelPathBuilder(false).append(leftParts.slice(i));
            const targetPartDifference = new ModelPathBuilder(false).append(rightParts.slice(i));
            differentSuffix = {
                kind: MatchKind.DifferentSuffix,
                source: !sourcePartDifference.empty ? sourcePartDifference.toPath() : undefined,
                target: !targetPartDifference.empty ? targetPartDifference.toPath() : undefined,
            };
            break;
        }
        if (!samePrefix.empty) {
            result.push({
                kind: MatchKind.MatchedPath,
                prefix: samePrefix.toPath(),
            });
        }
        if (differentSuffix != undefined) {
            result.push(differentSuffix);
        }
        return result;
    }
}
